<div *ngIf="formData" class="section-table-container" [ngClass]="{ 'beta-access-enabled': isBetaAccessPrivilegeConsumable }">
  <div class="outer-border foreign-key">
    <p-button
      type="button"
      label="Add Foreign Key"
      icon="pi pi-plus"
      (onClick)="addForeignKey()"
      *ngIf="!disableField"
      class="new-btn"
    />
  </div>
  <p-table
    [value]="foreignKeys"
    dataKey="sid"
    class="fil-map-table index-table"
    styleClass="p-datatable-gridlines sql-tables"
    [style]="{ width: '100%' }"
    [scrollable]="true"
  >
    <ng-template #header>
      <tr>
        <th>{{ 'NAME' | translate }}</th>
        <th>{{ 'REF_TABLE' | translate }}</th>
        <th>{{ 'REF_IND' | translate }}</th>
        <th class="w-100-px action-items"></th>
      </tr>
    </ng-template>
    <ng-template #body let-data>
      <tr>
        <td class="text-break">
          {{ data.fkName }}
        </td>
        <td class="text-break">
          {{ tableMap[data.parentTableSid] }}
        </td>
        <td class="text-break">
          {{ getIndexName(data?.parentIndexId, data?.parentIndexName) }}
        </td>
        <td class="tbl-action">
          <div *ngIf="!data.parentChildTableFk && !disableField">
            <svg-icon
              (click)="showWhereUsed(data)"
              [src]="svgPaths.whereUsed.default"
              class="where-used-icon icon-plus cursor-pointer mr-1"
              alt="where used"
              aria-hidden="true"
              showDelay="100"
              hideDelay="100"
              pTooltip="{{ 'WHERE_USED' | translate }}"
              tooltipPosition="top"
            ></svg-icon>
            <svg-icon
              (click)="editForeignKey(data)"
              src="assets\images\svg\edit.svg"
              class="icon-plus cursor-pointer edit-icon"
              alt="edit"
              aria-hidden="true"
              showDelay="100"
              hideDelay="100"
              pTooltip="Edit"
              tooltipPosition="top"
            ></svg-icon>
            <svg-icon
              (click)="deleteForeignKey(data)"
              src="assets\images\svg\trash.svg"
              class="icon-plus cursor-pointer"
              alt="delete"
              aria-hidden="true"
              showDelay="100"
              hideDelay="100"
              pTooltip="Delete"
              tooltipPosition="top"
            ></svg-icon>
          </div>
        </td></tr
    ></ng-template>
    <ng-template #emptymessage let-columns>
      <tr class="no-records">
        <td colspan="4" class="text-center">
          {{ 'NO_FOREIGN_CREATED' | translate }}
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>
<p-dialog
  [(visible)]="showAddForm"
  [style]="{ width: '55vw', height: '75vh' }"
  [draggable]="false"
  [modal]="true"
  appendTo="body"
  [styleClass]="isBetaAccessPrivilegeConsumable ? 'lifecycle-modal beta-access-enabled' : 'lifecycle-modal'"
  [closable]="false"
>
  <ng-template pTemplate="header">
    <span class="dialog-header"
      >{{ tableName }} - {{ (action === 'Save' ? 'FOREIGN_KEY' : 'FOREIGN_KEY') | translate }}
      {{
        action === 'Update'
          ? ' :
            '
          : ''
      }}
      <span class="dialog-subheader"> {{ action === 'Update' ? foreignKeyForm.get('fkName')?.value : '' }}</span>
    </span>
  </ng-template>
  <form [formGroup]="foreignKeyForm" class="fk-form">
    <div class="d-flex justify-content-center align-items-center w-100" *ngIf="isLoading">
      <div class="spinner-container">
        <p-progress-spinner></p-progress-spinner>
      </div>
    </div>
    <div class="form-group row">
      <label class="col-xs-6 col-sm-6 col-md-4 col-lg-4 col-xl-4 col-form-label required" for="ref-table">{{
        'REF_TABLE' | translate
      }}</label>
      <div class="col-xs-6 col-sm-6 col-md-8 col-lg-8 col-xl-8" id="ref-table">
        <p-select
          *ngIf="applicationType === 'INDEPENDENT'"
          [options]="tableList"
          [filter]="true"
          filterBy="name"
          formControlName="parentTableSid"
          optionLabel="name"
          trim="blur"
          optionValue="sid"
          [disabled]="disableField"
          placeholder="Select Table"
          class="form-control"
          panelStyleClass="ifkey-panel"
          [ngClass]="{ 'error-border': submitted && foreignKeyForm.get('parentTableSid')?.invalid }"
          (onChange)="onTblChange($event)"
          optionDisabled="inactive"
        ></p-select>
        <p-select
          *ngIf="applicationType !== 'INDEPENDENT'"
          [options]="groupedLookUpTables"
          (onChange)="onTblChange($event)"
          optionLabel="name"
          [filter]="true"
          filterBy="name"
          optionValue="sid"
          [disabled]="disableField"
          placeholder="Select Table"
          (onShow)="preventCollapse()"
          panelStyleClass="fkey-panel"
          formControlName="parentTableSid"
          [group]="true"
        >
          <ng-template let-option pTemplate="group">
            <div
              class="group-header"
              [ngClass]="{
                collapsed: !option.expanded,
                expand: option.expanded,
                selected: option.selected
              }"
              (click)="toggleGroup($event, option)"
              (keyup.enter)="toggleGroup($event, option)"
              tabindex="0"
              aria-label="toggle group"
            >
              <i class="pi" [ngClass]="{ 'pi-chevron-down': !option.expanded, 'pi-chevron-up': option.expanded }"></i>
              <span>{{ option.label }}</span>
            </div>
          </ng-template>
          <ng-template let-field pTemplate="item">
            <div class="field-item sub-group" [ngClass]="{ expanded: !field.expanded }" [class.ind-item]="field.ind">
              <div>{{ field.name }}</div>
            </div>
          </ng-template>
        </p-select>
      </div>
    </div>
    <div class="form-group row">
      <label class="col-xs-6 col-sm-6 col-md-4 col-lg-4 col-xl-4 col-form-label required" for="fkName">{{
        'FOREIGN_KEY_NAME' | translate
      }}</label>
      <div class="col-xs-6 col-sm-6 col-md-8 col-lg-8 col-xl-8">
        <input
          formControlName="fkName"
          id="fkName"
          type="fkName"
          class="form-control"
          trim="blur"
          maxlength="63"
          [disabled]="disableField"
          [ngClass]="{ 'error-border': submitted && foreignKeyForm.get('fkName')?.invalid }"
        />
      </div>
    </div>
    <div class="form-group row">
      <label class="col-xs-6 col-sm-6 col-md-4 col-lg-4 col-xl-4 col-form-label required" for="parentIndexId"
        >{{ 'REF_IND' | translate }}
        <i
          class="fa fa-info-circle field-info"
          showDelay="100"
          hideDelay="100"
          pTooltip="{{ 'IND_INFO' | translate }}"
        ></i>
      </label>
      <div class="col-xs-6 col-sm-6 col-md-8 col-lg-8 col-xl-8">
        <p-select
          [options]="indexList"
          formControlName="parentIndexId"
          optionLabel="indexName"
          [ngClass]="{ 'error-border': submitted && foreignKeyForm.get('parentIndexId')?.invalid }"
          optionValue="sid"
          trim="blur"
          [disabled]="disableField"
          placeholder="Select Index"
          (onChange)="onIndChange($event)"
          class="form-control"
          optionDisabled="inactive"
        ></p-select>
      </div>
    </div>
    <div class="form-group row">
      <label class="col-xs-6 col-sm-6 col-md-4 col-lg-4 col-xl-4 col-form-label required" for="mapping"
        >{{ 'MAPPING' | translate
        }}<i
          class="fa fa-info-circle field-info"
          showDelay="100"
          hideDelay="100"
          pTooltip="{{ 'MAP_INFO' | translate }}"
        ></i
      ></label>
      <div class="col section-table-container" id="mapping">
        <p-table
          #tb
          [value]="mappings"
          dataKey="sid"
          class="fil-map-table"
          styleClass="p-datatable-gridlines w-100"
          [style]="{ width: '100%' }"
          [scrollable]="true"
        >
          <ng-template #header>
            <tr>
              <th>{{ 'MAP_FROM_REF_TBL' | translate }} ({{ tableMap[foreignKeyForm.get('parentTableSid').value] }})</th>
              <th>{{ 'MAP_TO_CURR_TBL' | translate }} ({{ tableMap[formData.sid] }})</th>
            </tr>
          </ng-template>
          <ng-template #body let-data>
            <tr>
              <td class="w-50">
                <span class="required">{{ fieldMap[data.parent] }}</span>
              </td>
              <td class="hover-icon-cell w-50">
                <div class="custom-icon-wrapper">
                  <div [ngClass]="{ 'border-error': hasError(data), 'border-warning': hasWarning(data) }">
                    <p-autocomplete
                      #autoComplete
                      [(ngModel)]="data.child"
                      [class.bor-err]="data.errorMsg"
                      [ngModelOptions]="{ standalone: true, updateOn: 'change' }"
                      [suggestions]="results"
                      (onSelect)="onchildFldCng($event, data)"
                      trim="blur"
                      appendTo="body"
                      (completeMethod)="search($event, data)"
                      [dropdown]="true"
                      field="name"
                      [disabled]="disableField"
                      placeholder="Select"
                    >
                      <ng-template let-option pTemplate="item">
                        <span>{{ option.name }} </span>
                      </ng-template>
                    </p-autocomplete>
                  </div>
                  <span *ngIf="hasError(data)" class="error-icon-fk"
                    ><i
                      class="fa fa-exclamation-circle"
                      (mouseenter)="toggleWarningPopup(data, true)"
                      (mouseleave)="toggleWarningPopup(data, false)"
                    ></i
                  ></span>
                  <span *ngIf="hasWarning(data)" class="warning-icon"
                    ><i
                      class="fa fa-exclamation-triangle"
                      (mouseenter)="toggleWarningPopup(data, true)"
                      (mouseleave)="toggleWarningPopup(data, false)"
                    ></i
                  ></span>
                </div>

                <div class="warning-wrapper" *ngIf="data.showPopup">
                  <div
                    [ngClass]="{
                      'val-err': hasError(data),
                      'val-warning': hasWarning(data)
                    }"
                  >
                    <div class="warning-header">
                      <p *ngIf="hasError(data)">Error</p>
                      <p *ngIf="hasWarning(data)">Warning</p>
                      <i class="pi pi-times error-icon-fk"></i>
                    </div>
                    {{ data.errorMsg }}
                  </div>
                </div>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
  </form>
  <ng-template #footer>
    <div class="text-right update-form">
      <button type="button" class="btn btn-primary cancel-btn button-outlined" (click)="closeDialog()">
        {{ 'CANCEL' | translate }}
      </button>
      <button type="submit" class="btn btn-primary button-filled" (click)="onUpdate()" [disabled]="isLoading">
        {{ 'SAVE' | translate }}
      </button>
    </div>
  </ng-template>
</p-dialog>
